import { call, put } from "redux-saga/effects";
import { API_URLS } from "../../../config";
import {
    resetAttendanceLoading,
    storeMyAttendanceList,
    storeTodayAttendance,
} from "../../redux/slices/attendanceSlice";
import { CallApi } from "./api/callApi";


export function* listMyAttendanceSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.USERS.ATTENDANCE.ROUTE, data?.data, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeMyAttendanceList(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* createAttendanceSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.ATTENDANCE.ROUTE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getTodayAttendanceSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.USERS.ATTENDANCE.GET_TODAY_ATTENDANCE, data?.data, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* closeTodayAttendanceSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.ATTENDANCE.CLOSE_ATTENDANCE, data?.data, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* updateAttendanceTimeSaga(action) {
    try {

        //console.log(action.payload);
        const data = action.payload;
        const { id,...timeData } = data?.data
        //console.log(id,timeData);
        const resp = yield call(CallApi.PATCH, `${API_URLS.USERS.ATTENDANCE.ROUTE}/${id}`, timeData, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* reopenAttendanceSaga(action) {
    try {
        const data = action.payload;
        const { id } = data?.data
        const resp = yield call(CallApi.PUT, API_URLS.USERS.ATTENDANCE.REOPEN_ATTENDANCE.replace(":id", id), null, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}




export function* generateMonthlyReportSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, API_URLS.USERS.ATTENDANCE.MONTHLY_ATTENDANCE_REPORT, data?.data, data?.token);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* createBreakSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.ATTENDANCE.BREAK.CREATE_BREAK, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* updateBreakSaga(action) {
    try {
        const {data,token} = action.payload;
        const {id,...rest}=data
        
        const resp = yield call(CallApi.PATCH, `${API_URLS.USERS.ATTENDANCE.BREAK.ROUTE}/${id}`, rest, token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* closeBreakSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.ATTENDANCE.BREAK.CLOSE_BREAK, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(storeTodayAttendance(resp.data.data))
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(resetAttendanceLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(resetAttendanceLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}